import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import { RechnungPosition, deleteRechnungPosition } from 'api/rechnungPosition';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';

interface RechnungPositionDeleteProps {
    rechnungPosition: RechnungPosition;
    onClose: (refetch: boolean) => void;
}

export const RechnungPositionDelete: React.FC<RechnungPositionDeleteProps> = ({ rechnungPosition, onClose }) => {
    const [savingState, setSavingState] = React.useState(SavingState.notChanged);

    const onDelete = () => {
        if (rechnungPosition && savingState !== SavingState.saving) {
            setSavingState(SavingState.saving);
            deleteRechnungPosition(rechnungPosition)
                .then(() => {
                    setSavingState(SavingState.saved);
                    onClose(true);
                })
                .catch((error) => {
                    console.error(error);
                    setSavingState(SavingState.error);
                });
        }
    };

    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: 'Rechnungsposition löschen',
                subText: 'Rechnungsposition "' + rechnungPosition.posText + '" löschen?',
                type: DialogType.normal,
            }}
        >
            {savingState === SavingState.error && <div className={formStyles.error}>Fehler beim Löschen.</div>}

            <DialogFooter>
                {savingState !== SavingState.saving && (
                    <DefaultButton
                        onClick={() => {
                            onClose(false);
                        }}
                        text="Abbrechen"
                    />
                )}

                {savingState === SavingState.saving ? (
                    <DefaultButton text="Lösche..." disabled />
                ) : (
                    <PrimaryButton
                        onClick={onDelete}
                        text="Löschen"
                        disabled={savingState !== SavingState.notChanged}
                    />
                )}
            </DialogFooter>
        </Dialog>
    );
};
